<template>
    <div class="body">

        <div  :style="{'display':refund}">
            <el-image style="width: 100px; height: 100px" :src="result.logo" fit="fit"></el-image>
            <p class="name">{{result.expName}}</p>
            <p class="name">总耗时：{{result.takeTime}}</p>

        </div>

        <div>
                <el-timeline class="timeline">
                    <el-timeline-item v-for="(item,index) in result.list" :key="index"  :timestamp="item.time" placement="top">
                    <el-card>
                        <h4>{{item.status}}</h4>
                        <p>提交于{{item.time}}</p>
                    </el-card>
                    </el-timeline-item>
                </el-timeline>
                <el-button type="primary"  @click="dialogVisible = true">{{name}}</el-button>

                 <el-dialog title="物流信息" :visible.sync="dialogVisible"  width="30%" :before-close="handleClose">
           
                    <el-select v-model="expressForm.type" filterable  placeholder="请选择物流公司">
                        <el-option v-for="item in options" :key="item.code" :label="item.name"  :value="item.code"></el-option>
                    </el-select>
                    <p class="waybill">运单编号:</p>
                    <el-input v-model="expressForm.number" class="number" placeholder="请输入内容"></el-input>


                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary"  @click="sendExpress">确 定</el-button>
                    </span>
                </el-dialog>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('product')
export default {
    data(){
        return{
            result:{},
            dialogVisible: false,
            options: [],
            value: '',
            input: '',
            refund:'none',
            name:'添加物流信息',
            visibility:'hidden',
            expressForm:{
                id:null,
                type:null,
                number:null,
                orderId:''
            }
        }
    },
    mounted(){
        this.home();
        this.express();
        this.expressForm.orderId =this.orderId
    },
    computed:{
      ...mapState({
         orderId:state=>state.orderId
      })
    },
    methods:{
        home(){
            this.joker.store.orderLogistics(this.orderId).then(res=>{
                console.log(res.content)
                if(res.content==null){
                }else{
                    this.result = res.content
                    this.expressForm.id = res.content.id
                    this.expressForm.type = res.content.type
                    this.expressForm.number = res.content.number
                    this.name = '修改物流信息'
                    this.refund = 'block'
                }
            })
        },
        express(){
            this.joker.store.express().then(res=>{
                console.log(res)
                this.options = res.content
            })
        },
        //添加订单
        sendExpress(){
            this.dialogVisible  = false
            console.log(this.expressForm)
            if(this.expressForm.id == null){ //添加
           
                if(this.expressForm.number==null){
                     console.log("1")
                    this.joker.store.addExpressX(this.expressForm.id).then(res=>{
                        alert('出货成功')
                    })
                }else{
                    this.joker.store.addExpress(this.expressForm).then(res=>{
                        alert('添加成功')
                    })
                }
            }else{//修改
                this.joker.store.updateExpress(this.expressForm).then(res=>{
                    alert('修改成功')
                })
            }
        },

        handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
    }
}
</script>

<style scoped>

.timeline{
    width: 50%;
    margin-left: 20%;
}

.name{
    height: 60px;
    font-size: 26px;
}

.waybill{
    margin-top: 3%;
}

.number{
    width: 40%;
}

</style>


// WEBPACK FOOTER //
// src/components/Store/Order/OrderLogistics.vue